import $ from 'jquery';

export const choose = ($holder, $input) => {
    if ($input.attr('type') === 'radio' && !$holder.hasClass('fn-active')) {
        const form = $input.parents(elements.fieldset);
        const otherHolders = form.find('.js-Radio-Holder').not($holder);

        otherHolders.each(function () {
            const $this = $(this);
            const input = $this.find('input[type="radio"]');

            if (input.length) {
                $this.removeClass('fn-active');
                input.prop('checked', false);
            }
        });

        $holder.addClass('fn-active');
        $input.prop('checked', true);
    }
};

export const elements = {
    call: '.js-Radio-Call',
    holder: '.js-Radio-Holder',
    fieldset: '.js-Radio-Fieldset',
};

export const onEvent = function (event) {
    event.stopPropagation();
    const $this = $(this);
    const holder = $this.parents(elements.holder);
    const input = holder.find('input').first();

    choose(holder, input);
};

export default {
    init(params) {
        params.$document
            .off('change click', elements.call)
            .on('change click', elements.call, onEvent);
    },
};



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/radio-button.js